
const BannerBg = ({ className }: any) => {
    return (
        <svg className={className} width="250" height="245" viewBox="0 0 250 245" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle opacity="0.6" cx="291.836" cy="165.473" r="135.108" transform="rotate(-15 291.836 165.473)" fill="url(#paint0_linear_1325_6552)" />
            <circle cx="156.957" cy="267.55" r="135.108" transform="rotate(-15 156.957 267.55)" fill="url(#paint1_linear_1325_6552)" />
            <defs>
                <linearGradient id="paint0_linear_1325_6552" x1="291.836" y1="30.3653" x2="291.836" y2="300.581" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#84CAFF" stopOpacity="0" />
                    <stop offset="1" stopColor="#84CAFF" />
                </linearGradient>
                <linearGradient id="paint1_linear_1325_6552" x1="156.957" y1="132.442" x2="156.957" y2="402.658" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#84CAFF" stopOpacity="0" />
                    <stop offset="1" stopColor="#8A84FF" />
                </linearGradient>
            </defs>
        </svg>

    )
}

export default BannerBg
